var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLSquareSpoilerArrow",on:{"click":_vm.arrowClick}},[_c('ArrowMiniIcon',{staticClass:"LLSquareSpoilerArrow__arrow",class:_vm.arrowClasses})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }